import { useCallback, useEffect, useRef, useState } from 'react';

import { copyToClipboard } from '@src/common';

const COPIED_TOOLTIP_MS = 3000;

/**
 * Copies a value and reports `copied` for a few seconds, so the confirmation can float over the
 * layout instead of pushing it around. Repeated copies restart the window rather than stacking.
 */
export const useCopyFeedback = (value: string, feedbackMs: number = COPIED_TOOLTIP_MS) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const copy = useCallback(() => {
    copyToClipboard(value);
    setCopied(true);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setCopied(false), feedbackMs);
  }, [value, feedbackMs]);

  return { copied, copy };
};

export default useCopyFeedback;
